import { logger } from '@old/services/logger';
import { useShouldShowFeatureFlag } from 'common/features/FeatureFlag/hooks/useFeatureFlag';
import { useActivateMyFcmTokenMutation } from 'common/schema/commonSchemaRemoteGraphqlQueries';
import { PermissionTypes } from 'stacks/PermissionsModal/store/permissionsStateSlice';
import useAppSelector from '../../../hooks/useAppSelector';
import { useSelectedProfile } from '../../../hooks/useSelectedProfile';

export const usePostLoginActions = () => {
  const [isUnityWebview] = useShouldShowFeatureFlag('unityWebView');
  const permissionsData = useAppSelector((store) => store.permissionsState);
  const selectedProfile = useSelectedProfile();
  const { deviceId } = permissionsData[PermissionTypes.Notifications];
  const [activateFCMToken] = useActivateMyFcmTokenMutation();

  const handlePostLoginActions = () => {
    // #1. Activate FCM token
    if (isUnityWebview) {
      activateFCMToken({ variables: { platform: deviceId } })
        .then((result) => {
          if (!result.data?.activateMyFCMToken) {
            logger.info(`No FCM token found for device id: ${deviceId}.`);
          }
        })
        .catch((error) => {
          logger.error(
            error,
            `Error activating FCM token on login, for profile ${selectedProfile?.id}, device id: ${deviceId}.`
          );
        });
    }
  };

  return handlePostLoginActions;
};
